import React from 'react';
import {IconSVG} from "../icon/IconSVG";
import colorUtils from "../../colorUtils";

const WarningMsg = ({msg}: { msg: string }) => {
    return (
        <div className={'d-flex gap-2 align-items-center pb-1'}>
            <IconSVG icon={'/assets/icons/info.svg'} tintColor={colorUtils.theme.orange}/>
            <small
                className={'text-orange-500'}>{msg}</small>
        </div>
    );
};

export default WarningMsg;
